import React from 'react';
import { ArrowLeft, ArrowRight, Save } from 'lucide-react';

const STEPS = {
    ENTRY_TYPE: 'step_1_entry_type',
    TEMPLATE: 'step_3_template',
    DETAILS: 'step_4_details',
    PREVIEW: 'step_5_preview'
};

const BookkeepingNavigationBar = ({
    activeStep,
    onStepChange,
    operationInProgress,
    canProceedToNext,
    canGoBack,
    getNextStep,
    getPreviousStep,
    onCreateVerification
}) => {
    const isLastStep = activeStep === STEPS.PREVIEW;

    return (
        <>
            <style>{`
                .navigation-bar {
                    background: white;
                    border: 1px solid #e5e7eb;
                    border-radius: 12px;
                    padding: 1.5rem 2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }
                
                .nav-button {
                    border-radius: 8px;
                    padding: 0.75rem 1.5rem;
                    font-weight: 600;
                    font-size: 0.875rem;
                    border: none;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    cursor: pointer;
                    min-width: 120px;
                    justify-content: center;
                }
                
                .btn-nav-secondary {
                    background: #f1f5f9;
                    color: #64748b;
                    border: 1px solid #e2e8f0;
                }
                
                .btn-nav-secondary:hover:not(:disabled) {
                    background: #e2e8f0;
                    color: #475569;
                    transform: translateY(-1px);
                }
                
                .btn-nav-primary {
                    background: var(--bs-primary);
                    color: white;
                }
                
                .btn-nav-primary:hover:not(:disabled) {
                    background: var(--bs-primary);
                    transform: translateY(-1px);
                }
                
                .btn-nav-success {
                    background: var(--bs-primary);
                    color: white;
                    box-shadow: 0 4px 12px var(--rgba-primary-3);
                }

                .btn-nav-success:hover:not(:disabled) {
                    background: var(--primary-hover);
                    transform: translateY(-1px);
                    box-shadow: 0 6px 16px var(--rgba-primary-4);
                }
                
                .nav-button:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                    transform: none;
                }
                
                .loading-spinner {
                    width: 16px;
                    height: 16px;
                    border: 2px solid rgba(255, 255, 255, 0.3);
                    border-top: 2px solid currentColor;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }
                
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                .nav-center {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                }
                
                .step-indicator {
                    font-size: 0.875rem;
                    color: #64748b;
                    background: #f8fafc;
                    padding: 0.5rem 1rem;
                    border-radius: 20px;
                    border: 1px solid #e2e8f0;
                }
                
                /* Mobile responsive */
                @media (max-width: 768px) {
                    .navigation-bar {
                        flex-direction: column;
                        gap: 1rem;
                        align-items: stretch;
                        padding: 1.5rem;
                    }
                    
                    .nav-button {
                        min-width: auto;
                    }
                    
                    .nav-center {
                        order: -1;
                        justify-content: center;
                    }
                }
            `}</style>

            <div className="navigation-bar">
                <div>
                    {canGoBack ? (
                        <button
                            className="nav-button btn-nav-secondary"
                            onClick={() => onStepChange(getPreviousStep(), 'backward')}
                            disabled={operationInProgress}
                        >
                            <ArrowLeft size={16} />
                            Föregående
                        </button>
                    ) : (
                        <div style={{ width: '120px' }}></div>
                    )}
                </div>

                <div className="nav-center">
                    <div className="step-indicator">
                        Steg {activeStep === STEPS.ENTRY_TYPE ? '1' :
                            activeStep === STEPS.TEMPLATE ? '2' :
                                activeStep === STEPS.DETAILS ? '3' : '4'} av 4
                    </div>
                </div>

                <div>
                    {isLastStep ? (
                        <button
                            className="nav-button btn-nav-success"
                            onClick={onCreateVerification}
                            disabled={operationInProgress}
                        >
                            {operationInProgress ? (
                                <>
                                    <div className="loading-spinner" />
                                    Skapar...
                                </>
                            ) : (
                                <>
                                    <Save size={16} />
                                    Skapa Verifikat
                                </>
                            )}
                        </button>
                    ) : (
                        <button
                            className="nav-button btn-nav-primary"
                            onClick={() => onStepChange(getNextStep(), 'forward')}
                            disabled={!canProceedToNext || operationInProgress}
                        >
                            Nästa
                            <ArrowRight size={16} />
                        </button>
                    )}
                </div>
            </div>
        </>
    );
};

export default BookkeepingNavigationBar;